import { inject, injectable } from 'inversify';
import SenderType from './SenderType';
import SocketSender from './senders/SocketSender';
import BeaconSender from './senders/BeaconSender';
import Tracker from '../Tracker';

@injectable()
class SenderFactory {
  constructor(
    @inject(BeaconSender) private beaconSender: BeaconSender,
    @inject(SocketSender) private socketSender: SocketSender,
  ) {}

  create(senderType: SenderType = SenderType.Socket): Tracker {
    switch (senderType) {
      case SenderType.Beacon:
        return this.beaconSender;
      case SenderType.Socket:
        return this.socketSender;
      default:
        throw Error('Undefined Sender Type');
    }
  }
}

export default SenderFactory;
